module.exports = __webpack_public_path__ + "img/nutrition.fecb3075.svg";